<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelTemplatePromo"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="option" slot-scope="{ option }">
      <div class="d-flex align-items-center">
        <span
          v-if="option.id !== null && option.id_empresa"
          class="badge badge-secondary badge-sm mr-2 badge-option"
        >
          {{ getNomeEmpresa(option.id_empresa) }}
        </span>
        <span>{{ option.nome }}</span>
      </div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false,
      empresasMap: {}
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'templatePromo', null);
        return;
      }
      this.$emit('selectChange', 'templatePromo', e);
      this.$emit('focus');
    },
    labelTemplatePromo({ nome, id_empresa }) {
      const nomeEmpresa = this.empresasMap[id_empresa] || id_empresa;
      return `${nomeEmpresa} - ${nome}`;
    },
    getNomeEmpresa(idEmpresa) {
      return this.empresasMap[idEmpresa] || idEmpresa;
    },
    setValue(value) {
      if (value) {
        if (typeof value == 'number') {
          this.selected = this.options.find((option) => option.id === value);
        } else {
          this.selected = this.options.find((option) => option.id === value.id);
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    async setOptions() {
      let empresasPermitidas = [this.$store.state.user.info.id_empresa];
      try {
        const idsPermissoesNegocio = this.$util.getIdsPermissoesNegocios();
        if (idsPermissoesNegocio?.length) {
          empresasPermitidas = idsPermissoesNegocio;
        }
      } catch (err) {
        console.log('Permissões de negócio não disponíveis, usando apenas empresa logada');
      }

      const empresasFilter = `id_empresa IN (${empresasPermitidas.join(',')})`;
      this.isLoading = true;

      try {
        const [empresasRes, templatesRes] = await Promise.all([
          this.$api.search('entity/empresa', {
            columns: 'id,nome',
            filter: `id IN (${empresasPermitidas.join(',')})`
          }),
          this.$api.search('entity/template_promo', {
            columns: 'id,nome,metadata_padrao,id_empresa',
            filter: `excluido = false AND ativo=true AND ${empresasFilter}`,
            order: 'nome'
          })
        ]);

        this.empresasMap = {};
        if (empresasRes.data?.length) {
          empresasRes.data.forEach((empresa) => {
            this.empresasMap[empresa.id] = empresa.nome;
          });
        }

        this.options = this.includeAll ? [{ id: null, nome: this.$i18n.t(this.emptyLabel) }] : [];
        this.options = this.options.concat(templatesRes.data || []);
        this.setValue(this.nameField);
      } catch (err) {
        this.$util.formWarn({
          msgTitle: 'Erro ao Carregar Dados',
          msgContent: 'Entre em contato com o Administrador do Sistema.',
          type: 'error'
        });
      } finally {
        this.isLoading = false;
      }
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-option {
  font-size: 0.7rem;
  padding: 2px 6px;
}
</style>
